"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyEvent = applyEvent;
const designReducer_1 = require("./reducers/designReducer");
const planReducer_1 = require("./reducers/planReducer");
const dates_1 = require("./dates");
function applyEvent(weave, event) {
    const updatedDocs = [...weave.allDocs];
    const changed = new Set();
    let designUpdated = false;
    let updatedDesignId = null;
    let newDesignVersion = null;
    for (let i = 0; i < updatedDocs.length; i++) {
        const doc = updatedDocs[i];
        if (doc.type === 'design') {
            const designDoc = doc;
            if (event.type === 'REFINE_DESIGN') {
                const updated = (0, designReducer_1.designReducer)(designDoc, event);
                updatedDocs[i] = updated;
                changed.add(designDoc.id);
                designUpdated = true;
                updatedDesignId = designDoc.id;
                newDesignVersion = updated.version;
            }
            else if (['ACTIVATE_DESIGN', 'CLOSE_DESIGN', 'REOPEN_DESIGN', 'FINALISE_DESIGN', 'CANCEL_DESIGN'].includes(event.type)) {
                updatedDocs[i] = (0, designReducer_1.designReducer)(designDoc, event);
                changed.add(designDoc.id);
            }
        }
        if (doc.type === 'plan') {
            const planDoc = doc;
            const eventPlanId = event.planId;
            if (eventPlanId && planDoc.id !== eventPlanId)
                continue;
            if (['ACTIVATE_PLAN', 'START_IMPLEMENTING_PLAN', 'COMPLETE_STEP', 'UPDATE_STEP', 'ADD_STEP', 'REMOVE_STEP', 'REORDER_STEPS', 'RECORD_RELEASE', 'FINISH_PLAN', 'BLOCK_PLAN', 'UNBLOCK_PLAN', 'CANCEL_PLAN'].includes(event.type)) {
                updatedDocs[i] = (0, planReducer_1.planReducer)(planDoc, event);
                changed.add(planDoc.id);
            }
        }
    }
    // Mark child plans stale if their parent design was refined
    if (designUpdated && updatedDesignId && newDesignVersion) {
        for (let i = 0; i < updatedDocs.length; i++) {
            const doc = updatedDocs[i];
            if (doc.type === 'plan') {
                const planDoc = doc;
                if (planDoc.parent_id === updatedDesignId) {
                    updatedDocs[i] = {
                        ...planDoc,
                        staled: true,
                        updated: (0, dates_1.today)(),
                    };
                    changed.add(planDoc.id);
                }
            }
        }
    }
    const updatedById = new Map(updatedDocs.map(d => [d.id, d]));
    const updatedThreads = weave.threads.map(thread => ({
        ...thread,
        idea: thread.idea ? updatedById.get(thread.idea.id) : undefined,
        design: thread.design ? updatedById.get(thread.design.id) : undefined,
        plans: thread.plans.map(p => updatedById.get(p.id) ?? p),
        dones: thread.dones.map(d => updatedById.get(d.id) ?? d),
        chats: thread.chats.map(c => updatedById.get(c.id) ?? c),
        allDocs: thread.allDocs.map(d => updatedById.get(d.id) ?? d),
    }));
    const updatedWeave = {
        id: weave.id,
        threads: updatedThreads,
        looseFibers: weave.looseFibers.map(f => updatedById.get(f.id) ?? f),
        chats: weave.chats.map(c => updatedById.get(c.id) ?? c),
        refDocs: weave.refDocs,
        allDocs: updatedDocs,
    };
    return { weave: updatedWeave, changed: [...changed] };
}
